// File: src/components/pages/Templates.jsx
// Tab-based page with Configuration tab as first tab
// REFACTORED: Now matches Students.jsx layout and structure

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Calendar } from 'lucide-react';
import SlotTemplates from '../SlotTemplates';
import Publish from './Publish';
import InstructorConfiguration from './InstructorConfiguration';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import { useActingAs } from '../../context/ActingAsContext';
import '../../styles/unified.css';

export default function Templates() {
  const { user } = useAuth0();
  const [activeTab, setActiveTab] = useState('templates');

  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isServiceProvider      = userRoles.includes('ServiceProvider');
  const isServiceProviderAdmin = userRoles.includes('ServiceProviderAdmin');

  const { isActingAsSelf } = useActingAs();

  // Configuration tab shown for:
  //  - ServiceProvider (always — their own configuration)
  //  - ServiceProviderAdmin, only while impersonating a selected instructor
  //    (matches the access check inside InstructorConfiguration.jsx)
  const canAccessConfig = isServiceProvider
    || (isServiceProviderAdmin && !isActingAsSelf);

  // Tab configuration - Configuration tab first (if accessible)
  const instructorTabs = canAccessConfig
    ? [{ key: 'configuration', label: 'Configuration', color: '#8b5cf6' }]
    : [];

  // Base tabs visible to all users
  const baseTabs = [
    { key: 'templates', label: 'Templates', color: '#667eea' },
    { key: 'publish', label: 'Publish', color: '#10b981' },
    { key: 'activate', label: 'Activate', color: '#f59e0b' },
    { key: 'changes', label: 'Changes', color: '#6b7280' }
  ];

  // Configuration tab appears first (if ServiceProvider)
  const tabs = [...instructorTabs, ...baseTabs];

  return (
    <div className="page-container">
      {/* Page Header - Matching Students.jsx structure 
      <div className="page-header">
        <div className="page-header-left">
          <Calendar size={32} className="page-icon" />
          <h1 className="page-title">Configurations</h1>
        </div>
      </div>
      */} 
      {/* Status Tabs - Matching Students.jsx structure */}
      <div className="status-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
            style={{
              '--tab-color': tab.color,
              borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area - Matching Students.jsx structure */}
      <div className="page-content">
        {/* Configuration Tab - Only for ServiceProvider (appears first) */}
        {activeTab === 'configuration' && (
          <InstructorConfiguration />
        )}

        {/* Templates Tab - Reuse existing component */}
        {activeTab === 'templates' && (
          <SlotTemplates />
        )}

        {/* Publish Tab */}
        {activeTab === 'publish' && (
          <Publish />
        )}

        {/* Activate Tab */}
        {activeTab === 'activate' && (
          <div className="tab-content-placeholder">
            <h2>Activate Template</h2>
            <p>Activate or deactivate your templates</p>
          </div>
        )}

        {/* Changes Tab */}
        {activeTab === 'changes' && (
          <div className="tab-content-placeholder">
            <h2>Change History</h2>
            <p>View history of changes made to your templates</p>
          </div>
        )}
      </div>
    </div>
  );
}